import React from 'react';
import { TitleMedium } from '../../common/components/v2';
import styles from './styles.module.scss';

export const PPWBHeader = () => {
  const title = 'Product Performance Work Bench';
  return (
    <div className={styles.Header}>
      <div>
        <TitleMedium>{title}</TitleMedium>
      </div>
    </div>
  );
};
